import PageUpdated from './PageUpdated'

export default PageUpdated



// WEBPACK FOOTER //
// ./src/legacy/components/PageUpdated/index.js